(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('PaynetMode', PaynetMode);

    PaynetMode.$inject = ['$resource', 'DateUtils'];

    function PaynetMode ($resource, DateUtils) {
        var resourceUrl =  'api/paynet-modes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }

    CardPrefixConfig.$inject = ['$resource', 'DateUtils'];

    function CardPrefixConfig ($resource, DateUtils) {
        var resourceUrl =  'api/card-prefix-configs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
